import { Outlet } from "react-router-dom";
import MenuBar from "./menuBar";
import { useState } from "react";
import Footer from "./Components/footer";

const Layout = () => {
    const [lang, setLang] = useState<any>({ name: 'EN', code: 'GB', lang: "en" })

    return (
        <div className="flex flex-column overflow-x-hidden">
            <div className="flex flex-column px-2 py-3">
                <MenuBar lang={lang} setLang={setLang} />
            </div>
            <Outlet />
            <Footer />
        </div>
    )
}

export default Layout;